import styled from 'styled-components';
import {
  Popover, Button, Divider, Col, Row, Spin, Tabs,
  Checkbox,
} from 'antd';
import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import {
  primaryColor,
  primaryFont, primaryHeadingColor, secondaryFont, wMedium, maxWidth, retina, driver, wMBold,
} from 'Utils/utilsStyle';
// svgs

import classNames from 'classnames';
import { Params, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { allValueInKeyOfArrayExists, smoothBehavior } from 'Utils/UtilityFunctions';
import AlertsSearch from 'Components/alerts/components/AlertsSearch';
import { SLFilterType } from 'Types/ServiceLinesTypes';
import { Filter } from 'Types/FilterTypes';
import {
  ALERTS, COMPANIES, NODATAFOUND, SLALERTS, SLCOMPANIES,
} from 'Utils/Constants';
import FilterDarkIcon from '../assets/svgIcons/FilterDarkIcon';
import FilterIcon from '../assets/svgIcons/FilterIcon';

import AlertsTriggersCheckBox from '../../alerts/components/AlertsTriggersCheckBox';
import FeedLoadingSkeleton from '../skeleton/FeedFilterSkeleton';
import CompanyWidgetSmall from './CompanyWidgetSmall';
import NoDataFound from './NoDataFound';

const ContentWrapper = styled.div`
  h2 {
    font-size: 28px;
    color: ${primaryHeadingColor};
    font-weight: 800;
    font-family: ${secondaryFont};
    letter-spacing: -0.45px;
    line-height: 1.111 !important;
    margin-bottom: 0px;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 20px;
    }
  }
  svg{
     @media all and (max-width: ${maxWidth}) , ${retina} {
      max-width: 16px;
    }
  }
  p {
    font-size: 16px;
    color: #7E7E7E !important;
    font-weight: ${wMedium};
    font-family: ${primaryFont};
    letter-spacing: -0.4px;
    margin: 0;
  }
  .upperPart{
    padding: 20px 23px 20px 23px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 20px 16px 20px 16px;
    }
    .no-filter{
      color: ${driver} !important;
      text-align: center;
      margin: 10px 0 -10px 0;
    }
  }
  .lowerPart{
    padding: 0 47px 20px 23px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      padding: 0 16px 20px 16px;
    }
  }
  .userInfoSection {
    margin-top: 18px;
  }
  .linksSection {
    margin-top: 0px;
    padding: 18px 18px 20px 18px;
    background-color: #F8F8F8;
    border-radius: 0 0 20px 20px;
     @media all and (max-width: ${maxWidth}) , ${retina} {
      border-radius: 0 0 10px 10px;
    }
    .heading-panel{
      button{
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size:12px;
          padding: 0;
        }
      }
      h6.head{
        @media all and (max-width: ${maxWidth}) , ${retina} {
          font-size:12px;
        }
      }
    }
  }
  .linkMarginTop {
    padding-top: 18px;
  }
  .filter-btn {
    display: inline-block;
    border-radius: 8px;
    background-color: ${primaryColor};
    color: #fff;
    font-family: Roboto;
    font-weight: 900;
    font-size: 14px;
    line-height: 14px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 0px;
    &:hover {
      border-color: ${primaryColor} !important;
      background-color: transparent !important;
      color: ${primaryColor} !important;
    }
  }
  .disabled-btn {
    opacity: 0.7;
    pointer-events: none;
  }
  .filter-tab-with-company {
    margin-top: 0px;
    &.KPMGFlagActive {
     width: 100%;
     .ant-tabs-nav {
     margin: 0px 20px;
     }
     .ant-tabs-nav-list {
      width: 100%;
      .ant-tabs-tab  {
        width: 100%;
        .ant-tabs-tab-btn {
          width: 100%;
          text-align: center;
        }
      }
     }
     .grid-checkbox-wrapper {
      .category-filter {
        .filter-item {
          .filter-parent {
            .ant-checkbox-wrapper {
              .ant-checkbox-label {
                .color-div {
                  display: none;
                }
                .title-name {
                  color: #67696A;
                  font-family: ${primaryFont};
                  font-size: 16px;
                  font-weight: ${wMedium};
                  line-height: normal;
                  letter-spacing: -0.609px;
                  margin-left: 0px;
                }
              }
            }
          }
          .subfilters {
            margin-left: 20px;
            .subfilter-item {
              .ant-checkbox-wrapper {
                .ant-checkbox-label {
                  color: #67696A;
                  font-family: ${primaryFont};
                  font-size: 16px;
                  font-weight: ${wMedium};
                  line-height: normal;
                  letter-spacing: -0.609px;
                }
              }
            }
          }
        }
      }
     }
    }
    .ant-tabs-nav {
      margin-bottom: 0px !important;
    }
    .ant-tabs-nav-wrap {
      justify-content: center;
    }
    .ant-tabs-ink-bar {
      display: none;
    }
    .ant-tabs-tab {
      &:nth-child(1) {
        .ant-tabs-tab-btn {
          border-radius: 8px 0px 0px 8px !important;
        }
      }
      &:nth-child(2) {
        .ant-tabs-tab-btn {
          border-radius: 0px 8px 8px 0px !important;
        }
      }
      .ant-tabs-tab-btn {
        padding: 8px 40px;
      }
    }
    .companySmall-widget-filter {
      margin-bottom: 5px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        height: 75px;
      }
      .image-placeholder {
         width: 153px;
         height: 89%;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          width: 122px;
          height: 90%; // it is because of reason
        }
      }
    }
    .margin-to-set {
      margin: 0px 13px 0px 0px;
    }
    .show-company-name {
      font-family: ${secondaryFont};
      font-weight: ${wMBold};
      font-size: 12px;
      line-height: 14px;
      letter-spacing: -0.45px;
      color: ${primaryHeadingColor};
      margin-left: 5px;
      display: inline-block;
      margin-bottom: 20px;
      margin-top: 5px;
    }
    .grid-checkbox-wrapper {
     .search-wrapper, .ant-input-affix-wrapper {
       height: 35px !important;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        height: 32px !important;
      }
      .cross-icon {
        top: 9px;
        right: 9px;
        @media all and (max-width: ${maxWidth}) , ${retina} {
          top: 6px;
          right: 9px;
        }
      }
     }
    }
  }
  .no_data_found{
    height: 200px;
    width: 100%;
    div{
      height: 100%;
    }
  }
  .d-none {
    display:none;
  }
  .category-filter{
    margin-top: 2px;
  }
`;

const LoadingWrapper = styled.div`
  &.iconModeActive {
    .ant-spin-spinning {
      margin-top: 8px;
    }
  }
  height: 38px;
  .ant-spin-spinning {
   margin-top: 2px;
  }
`;

type Props = {
  onlyIcon?: boolean,
  loading?: boolean,
  filters: Filter[],
  customFilters?: Filter[],
  selectAllAllert?: boolean,
  selectAllAccount?: boolean,
  iconMode?: boolean,
  onChangeFilters?: (flag: boolean, id: string) => void,
  onChangeCustomFilters?: (flag: boolean, id: string) => void,
  onChangeCustomSubFilters?: (flag: boolean, id: string, subId: string) => void,
  onClickHandlerAlert?: () => void,
  onClickHandlerAccount?: () => void,
  applyFilterHandler?: () => void,
  disableApplyBtn?: boolean,
  KPMGFlag?: boolean
} & typeof defaultProps;

const defaultProps = {
  onlyIcon: true,
  loading: false,
  selectAllAllert: false,
  selectAllAccount: false,
  iconMode: false,
  customFilters: [] as Filter[],
  onChangeFilters: (a: true, id: '0') => { console.log(a, id); },
  onChangeCustomFilters: (a: true, id: '0') => { console.log(a, id); },
  onClickHandlerAlert: () => { },
  onClickHandlerAccount: () => { },
  applyFilterHandler: () => { },
  disableApplyBtn: false,
  KPMGFlag: false
  ,
};

const FilterPopOverWithCompany = function FilterPopOverWithCompany({
  onlyIcon,
  loading,
  filters,
  customFilters,
  selectAllAllert,
  selectAllAccount,
  iconMode,
  onChangeFilters,
  onChangeCustomFilters,
  onChangeCustomSubFilters,
  onClickHandlerAlert,
  onClickHandlerAccount,
  applyFilterHandler,
  disableApplyBtn,
  KPMGFlag
}: Props) {
  const { section } = useParams<Params>();
  const [popOverFilter, setPopOverFilter] = useState<Filter[]>();
  const [isNoFilterSelected, setIsNoFilterSelected] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>('');
  const [expandedFilters, setExpandedFilters] = useState<Record<string, boolean>>({});

  const toggleExpand = (filterId: string) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [filterId]: !prev[filterId],
    }));
  };

  useEffect(() => {
    let companyFilters = [] as Filter[]
    if (KPMGFlag) {
      companyFilters = (customFilters || []).filter(
        (item) => item.filterTypeName === SLCOMPANIES
          || item.filterTypeName === COMPANIES,
      );
    } else {
      companyFilters = (filters || []).filter(
        (item) => item.filterTypeName === SLCOMPANIES
          || item.filterTypeName === COMPANIES,
      );
    }

    const relevantFilters = KPMGFlag ? companyFilters : (filters || []);
    setIsNoFilterSelected(allValueInKeyOfArrayExists(relevantFilters, 'isSelected', false));
    setPopOverFilter(companyFilters);
  }, [filters, KPMGFlag, customFilters]);

  const applyData = () => {
    applyFilterHandler();
    smoothBehavior();
  };

  const searchCompanies = (searchTerm: string) => {
    let companyFilters: Filter[] = []
    if (KPMGFlag) {
      companyFilters = customFilters?.filter(
        (item) => item.filterTypeName === SLCOMPANIES || item.filterTypeName === COMPANIES,
      );
    } else {
      companyFilters = filters?.filter(
        (item) => item.filterTypeName === SLCOMPANIES || item.filterTypeName === COMPANIES,
      );
    }
    if (searchTerm !== '') {
      const tempFilter = companyFilters?.filter(
        (item) => item.filterName.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setPopOverFilter(tempFilter);
    } else {
      setPopOverFilter(companyFilters);
    }
    setSearchText(searchTerm);
  };

  const content = (
    <ContentWrapper>
      <div className="upperPart">
        <div className="d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center">
            <FilterDarkIcon />
            <h2 className="primary-color text-center ml-1">
              Filter
            </h2>
          </div>
          <div className="d-flex align-items-center">
            <Button
              onClick={applyData}
              className={`filter-btn ${(disableApplyBtn || isNoFilterSelected) ? 'disabled-btn' : ''}`}
              aria-label="Profile picture for menu"
            >
              Apply
            </Button>
          </div>
        </div>
        {isNoFilterSelected && <p className="no-filter">Please Select One Filter at Least</p>}
      </div>
      <Tabs defaultActiveKey={'1'} className={classNames('filter-tab-with-company', { 'KPMGFlagActive': KPMGFlag })}>
        {KPMGFlag ?
          <Tabs.TabPane tab="Sales Triggers" key="1">
            <div className="linksSection">
              <div className="heading-panel">
                <h6 className="head">{`${section === 'social' ? 'Social' : 'Categories'}`}</h6>
                <span className="unselect" onClick={onClickHandlerAlert} onKeyPress={onClickHandlerAlert} tabIndex={0} role="button" aria-label="unselect all">{selectAllAllert ? 'unselect all' : 'select all'}</span>
              </div>
              <div className="grid-checkbox-wrapper">
                <Row className="category-filter">
                  {loading ? (
                    <FeedLoadingSkeleton />
                  )
                    : (
                      <Col span={24}>
                        {customFilters?.filter(
                          (item) => item.filterTypeName === SLALERTS
                            || item.filterTypeName === ALERTS,
                        ).map(
                          (item) => {
                            const subFilters = item.subFilters || []
                            return (
                              <div key={item.filterId} className='filter-item'>
                                <div className='filter-parent'>

                                  <AlertsTriggersCheckBox
                                    title={item.filterName}
                                    color={item.filterColor}
                                    checked={item.isSelected}
                                    onCheckedChange={(checked) =>
                                      onChangeCustomFilters(checked, item.filterId)
                                    }
                                    id={item.filterId}
                                  />
                                </div>
                                {
                                  subFilters.length > 0 && (
                                    <div className='subfilters'>
                                      {
                                        subFilters.map((sub) => (
                                          <div key={sub.id} className='subfilter-item'>
                                            <Checkbox
                                              checked={sub.isSelected}
                                              onChange={(e) => onChangeCustomSubFilters?.(
                                                e.target.checked,
                                                item.filterId,
                                                sub.id
                                              )}
                                            >
                                              {sub.name}
                                            </Checkbox>
                                          </div>
                                        ))
                                      }

                                    </div>
                                  )
                                }
                              </div>

                            )
                          }
                        )}
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          </Tabs.TabPane> :
          <Tabs.TabPane tab="Sales Triggers" key="1">
            <div className="linksSection">
              <div className="heading-panel">
                <h6 className="head">{`${section === 'social' ? 'Social' : 'Categories'}`}</h6>
                <span className="unselect" onClick={onClickHandlerAlert} onKeyPress={onClickHandlerAlert} tabIndex={0} role="button" aria-label="unselect all">{selectAllAllert ? 'unselect all' : 'select all'}</span>
              </div>
              <div className="grid-checkbox-wrapper">
                <Row className="category-filter">
                  {loading ? (
                    <FeedLoadingSkeleton />
                  )
                    : (
                      <Col span={24}>
                        {filters?.filter(
                          (item) => item.filterTypeName === SLALERTS
                            || item.filterTypeName === ALERTS,
                        ).map(
                          (item) => (
                            <AlertsTriggersCheckBox
                              key={item.filterId}
                              title={item.filterName}
                              color={item.filterColor}
                              checked={item.isSelected}
                              onCheckedChange={onChangeFilters}
                              id={item.filterId}
                            />
                          ),
                        )}
                      </Col>
                    )}
                </Row>
              </div>
            </div>
          </Tabs.TabPane>
        }
        <Tabs.TabPane tab="Companies" key="2">
          <div className="linksSection">
            <div className="heading-panel">
              <h6 className="head">Companies:</h6>
              {searchText === '' ? <span className="unselect" onClick={onClickHandlerAccount} onKeyPress={onClickHandlerAccount} tabIndex={0} role="button" aria-label="unselect all">{selectAllAccount ? 'unselect all' : 'select all'}</span> : null}
            </div>
            <div className="grid-checkbox-wrapper">
              <AlertsSearch
                placeholderText="Find company..."
                loading={false}
                onSearching={searchCompanies}
                height="50px"
                margin="0px 13px 20px 0px"
              />
              <div className="margin-to-set">
                <Row gutter={12} className="w-100 margin-alert-to-center">
                  {popOverFilter?.map((company: SLFilterType) => (
                    <Col span={12} className={`${company?.filterName.toLowerCase().includes(searchText.toLowerCase()) ? '' : 'd-none'}`}>
                      <CompanyWidgetSmall
                        wrapperClassName="companySmall-widget-filter"
                        logo={company.logo || ''}
                        persona={company.personality || []}
                        triggerColor={company.pulse || []}
                        checked={company.isSelected}
                        selection={onChangeFilters}
                        companyId={company.filterId}
                        backgroundPosition="center 5px"
                        backgroundSize="50%"
                      />
                      <span className="show-company-name">{company.filterName}</span>
                    </Col>
                  ))}
                  {!popOverFilter?.length ? <div className="no_data_found"><NoDataFound title={NODATAFOUND} /></div> : null}
                </Row>
              </div>

            </div>
          </div>
        </Tabs.TabPane>
      </Tabs>

    </ContentWrapper>
  );

  return (
    loading
      ? (
        <LoadingWrapper className={classNames('tabs-wrapper justify-content-end loading-tab', { iconModeActive: iconMode })}>
          <div className="tabs-item filter-btn">
            <Spin />
          </div>
        </LoadingWrapper>
      )
      : (
        <Popover
          overlayClassName="global-filter"
          placement="bottomRight"
          content={content}
          overlayInnerStyle={{
            borderRadius: '20px',
            padding: '0px',
          }}
          trigger="click"
          getPopupContainer={(e: HTMLElement) => e}
          arrow={false}
          autoAdjustOverflow={false}
        >
          <div className={classNames('tabs-wrapper justify-content-end', { iconModeActive: iconMode })}>
            <Button
              className="tabs-item d-flex justify-content-center align-items-center global-tabs-item"
              aria-label="Filter Icon"
            >
              <FilterIcon />
              {
                onlyIcon ? (
                  <>
                    <span
                      className="filter-text"
                      style={{
                        marginLeft: '10px',
                        marginRight: '8px',
                      }}
                    >
                      Filter
                    </span>
                    <Divider type="vertical" />
                    <CaretDownOutlined />
                  </>
                ) : null
              }
            </Button>
          </div>
        </Popover>
      )
  );
};

FilterPopOverWithCompany.defaultProps = defaultProps;
export default FilterPopOverWithCompany;